var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.361 6.4602L10.619 8.5162C10.105 8.9012 9.37201 8.5352 9.37201 7.8932V3.7802C9.37201 3.1382 10.105 2.7722 10.618 3.1572L13.36 5.2132C13.776 5.5252 13.776 6.1482 13.361 6.4602Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.287C7.325 16.287 4.742 13.704 4.742 10.529C4.742 7.354 7.325 4.771 10.5 4.771C11.053 4.771 11.5 5.219 11.5 5.771C11.5 6.323 11.053 6.771 10.5 6.771C8.428 6.771 6.742 8.457 6.742 10.529C6.742 12.601 8.428 14.287 10.5 14.287C12.572 14.287 14.258 12.601 14.258 10.529C14.258 9.977 14.705 9.529 15.258 9.529C15.811 9.529 16.258 9.977 16.258 10.529C16.258 13.704 13.675 16.287 10.5 16.287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.2597f09c1024b874286e516ca4d905df.svg";
export { ForwardRef as ReactComponent };